module.exports = __webpack_public_path__ + "static/media/WETH.946772ab.svg";